import React from 'react';
import styled from 'styled-components';
import { Icon } from '~/components';
import { colors } from '~/styles';
import Pivot from '../Pivot';

// The icon is the only visible signal for status. Hours / capacity / missing hours
// live in the tooltip via the tool's metric fields.

const StatusIcon = styled.span`
  display: block;
  text-align: center;
  font-size: 0.75rem;
  color: ${({ color }) => color};
`;

const STATUS = {
  submitted: { tone: colors.success, icon: 'check' },
  // Partial isn't a warning — a week mid-submission is normal, not problematic.
  // Plain triangle in the primary teal reads as neutral / in-progress, not alarming.
  partial: { tone: colors.primary, icon: 'triangle' },
  unsubmitted: { tone: colors.danger, icon: 'times' },
};

function renderCell(contextRow) {
  if (!contextRow) return '';
  const meta = STATUS[contextRow.statusId];
  if (!meta) return '';
  return (
    <StatusIcon color={meta.tone}>
      <Icon icon={meta.icon} />
    </StatusIcon>
  );
}

export default function TimesheetSummaryPivot(props) {
  return <Pivot {...props} renderCell={renderCell} headerAlign="center" />;
}
